import { Box } from "@mui/material"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, Ref, UIEventHandler } from "react"

import { useAccountsPayableTransactionColumns } from "../../hooks/useAccountsPayableTransactionColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { VendorApLedgerEntry } from "@/graphql/codegen/graphql"

interface AccountsPayableTransactionTableProps {
  data: VendorApLedgerEntry[]
  loading: boolean
  error?: string
  showBalanceColumn: boolean
  containerRef?: Ref<HTMLDivElement>
  onScroll?: UIEventHandler<HTMLDivElement>
  onDocumentsOpen?: (entry: VendorApLedgerEntry) => void
}

export const AccountsPayableTransactionTable: FC<AccountsPayableTransactionTableProps> = ({
  data,
  loading,
  error,
  showBalanceColumn,
  containerRef,
  onScroll,
  onDocumentsOpen,
}) => {
  const columns = useAccountsPayableTransactionColumns({ showBalanceColumn, onDocumentsOpen })

  return (
    <Box data-testid='accounts-payable.transaction-table' className='flex min-h-0 flex-1 flex-col'>
      <AerosBaseTable<VendorApLedgerEntry>
        error={error ? { message: error } : undefined}
        features={{
          table: { stickyHeader: true },
          tanstackOptions: {
            data,
            columns,
            state: { isLoading: loading },
            getCoreRowModel: getCoreRowModel(),
            getRowId: (row) => row.vendorApLedgerEntryId,
          },
        }}
        slotProps={{
          container: { ref: containerRef, onScroll, className: "overflow-auto" },
        }}
        noDataMessage='No transactions found'
      />
    </Box>
  )
}
